import { gql } from "@apollo/client";
import React from "react";
import dayjs from "dayjs_with_plugins";
import styled from "styled-components";
import { PageHeading } from "components/PageHeading";
import { GraphqlQuery } from "graphqlUtils/GraphqlQuery";
import { Link } from "react-router-dom";
import { DatePickerSection } from "components/DatePickerSection";
import { CentredErrorIcon } from "components/CentredErrorIcon";
import { useParams } from "react-router-dom";
import { Loading } from "components/Loading";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Chip,
  TableRow,
  Link as MaterialUiLink,
} from "@mui/material";
import { FilterableNurseriesTable } from "containers/nurseries/FilterableNurseriesTable";

const TableWrapper = styled.div`
  background-color: white;
  margin-bottom: 30px;
  height: 650px;
  overflow-y: scroll;
`;

// exported for refetch in orders summary
export const NURSERIES_WITH_DIET_ADVICE = gql`
  query Nurseries($date: Date!) {
    nurseries {
      id
      name
      isActive
      dietAdviceStatus(date: $date)
    }
  }
`;

export const NurseryDietAdviceList = () => {
  const { date } = useParams();
  const TableHeadBorder = "1px solid rgb(224, 224, 224)";

  return (
    <PageHeading maxWidth="md" heading="Nursery Diet Advice">
      <DatePickerSection
        type="weekly"
        disableArrowKeys={false}
        maxDate={dayjs().add(6, "month").startOf("month")}
      />
      <GraphqlQuery query={NURSERIES_WITH_DIET_ADVICE} variables={{ date }} withError withLoading>
        {({ data, error, loading }) => {
          if (error) return <CentredErrorIcon />;
          if (loading) return <Loading />;
          return (
            <FilterableNurseriesTable data={data.nurseries}>
              {({ nurseriesList }) => {
                return (
                  <TableContainer component={TableWrapper}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ borderTop: TableHeadBorder, borderLeft: TableHeadBorder }}
                          >
                            Nursery
                          </TableCell>
                          <TableCell
                            style={{ borderTop: TableHeadBorder, borderRight: TableHeadBorder }}
                          >
                            Status
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {nurseriesList.map((nursery) => {
                          const { name, id } = nursery;
                          const colorFor = (status) => {
                            switch (status) {
                              case "Published":
                                return "primary";
                              case "Not Yet Published":
                                return "secondary";
                              case "No Diet Advice Created":
                                return "default";
                              default:
                                throw new Error("Unsupported Status");
                            }
                          };
                          return (
                            <TableRow key={name} hover>
                              <TableCell>
                                <Link key={id} to={`/diet-advice/${id}/date/${date}`}>
                                  <MaterialUiLink component="p">{name}</MaterialUiLink>
                                </Link>
                              </TableCell>
                              <TableCell>
                                <Chip
                                  variant="outlined"
                                  color={colorFor(nursery.dietAdviceStatus)}
                                  size="small"
                                  label={nursery.dietAdviceStatus}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                );
              }}
            </FilterableNurseriesTable>
          );
        }}
      </GraphqlQuery>
    </PageHeading>
  );
};
